import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../auth.service';

@Component({
  selector: 'tnt',
  templateUrl: './tnt.component.html',
  styleUrls: ['./tnt.component.scss'],
  host: { 'class': 'router-outlet' },
})
export class TntComponent implements OnInit {

  version = '2.0.0';
  constructor(
    public router: Router,
    public authService: AuthenticationService
  ) { }

  ngOnInit() { }

}
